export default __webpack_public_path__ + "static/media/about4.94c59fd3.gif";